import React from "react";
import "../css/Loading.css";
// Import the loading gif
import loadingGif from "../assets/Loading_icon.gif"; // Adjust the path as necessary

const Loading = () => {
    return (
        <div className="loading-container">
            <h2>Submitting your form...</h2>
            <img src={loadingGif} alt="Loading..." />
        </div>
    );
};

export default Loading;
